import React from 'react';
import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon, Button } from '@els/els-react--button';
import InnerHTML from '@Components/InnerHTML';

import './FindSimilarModalIntegratedDbsContent.scss';

function FindSimilarModalIntegratedDbsContent(props) {
  const { data, goTo, itemsForCurrentDB, itemsForAvailableDB } = props;
  const information = get(data, 'information');
  const image = get(data, 'image');

  return (
    <div className="find-similar-modal__content find-similar-modal__integrated-content">
      <InnerHTML className="find-similar-modal__content_title" tag="div" html={information} />
      {image && image.url && (
        <div className="find-similar-modal__integrated-content_image-container">
          <span>Query Structure</span>
          {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
          <img className="find-similar-modal__integrated-content_image-container_image" src={image.url} alt="find-similar-image" />
        </div>
      )}
      <div className="find-similar-modal__content_table rx-newmodal-content rx-newmodal-content-main">
        <table className="rx-table rx-table--full-width find-similar-table">
          <thead>
            <tr>
              <th scope="col">Database</th>
              {itemsForCurrentDB.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <th scope="col" key={`find-similar-table-th-${index}`}>
                  <div className="find-similar-table__col">
                    {item.description}
                    <Flyout
                      className="u-els-margin-left-1o4"
                      flyout={<div className="find-similar-table__dropdown u-els-font-size-base u-els-color-text">{item.help}</div>}
                      shouldCloseOnESC
                      showCloseButton
                      placement="bottom-start"
                      pointerType="primary">
                      <ButtonWithIcon
                        sprite="HelpOutlineCircle"
                        iconOnly
                        type="link"
                        linkIconSize="xs"
                        className={cn('e2e-dropdown', `e2e-${kebabCase(item.description)}`)}
                        onClick={noop}>
                        {item.description}
                      </ButtonWithIcon>
                    </Flyout>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {itemsForAvailableDB.map((databaseItem, databaseItemIndex) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={`find-similar-table-row-${databaseItemIndex}`}>
                  <td>
                    <span>{databaseItem && databaseItem.name}</span>
                  </td>
                  {databaseItem &&
                    databaseItem.items?.map((item, index) => {
                      const resultSize = get(item, 'resultSize');
                      return (
                        // eslint-disable-next-line react/no-array-index-key
                        <td key={`find-similar-table-td-${index}`}>
                          {resultSize && resultSize !== 0 ? (
                            <Button type="link" onClick={() => goTo(item)} className="e2e-find-similar-modal-goTo">
                              {resultSize && resultSize.toLocaleString()}
                            </Button>
                          ) : (
                            <span>{resultSize}</span>
                          )}
                        </td>
                      );
                    })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

FindSimilarModalIntegratedDbsContent.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    information: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
      label: PropTypes.string,
    }),
  }),
  goTo: PropTypes.func.isRequired,
  itemsForCurrentDB: PropTypes.array,
  itemsForAvailableDB: PropTypes.array,
};

export default FindSimilarModalIntegratedDbsContent;
